module.exports = __webpack_public_path__ + "assets/img/avatar_spotty.4142b111.png";